import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    ClientName: {
        validations: []
      },
      addressline1: {
        validations: [
          { type: 'required', message: 'Please fill in required field' },
        ]
      },
      city: {
        validations: [
          { type: 'required', message: 'Please fill in required field' },
        ]
      },
      state: {
        validations: [
          { type: 'required', message: 'Please fill in required field' },
        ]
      },
      postal: {
        validations: [
          { type: 'required', message: 'Please fill in required field' },
        ]
      },
      telnumber: {
        validations: [
          { type: 'required', message: 'Please fill in required field' },
          { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
        ]
      },
      cellnumber: {
          validations: [
            { type: 'required', message: 'Please fill in required field' },
          ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Email Address is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    website: {
      validations: []
    },
    partyname: {
      validations: [
        { type: 'required', message: 'Please fill in required field' },
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field' },
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field' },
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Main Contact First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Main Contact Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Company Name: (If Applicable)',
            mapping: 'ClientName'
        }
    ]
    },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Address:*',
          mapping: 'addressline1'
        }
      ]
    },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'City:*',
          mapping: 'city'
        },
        {
          type: 'text',
          size: 'Medium',
          label: 'State:*',
          mapping: 'state'
        },
        {
          type: 'text',
          size: 'Medium',
          label: 'Zip Code:*',
          mapping: 'postal'
        },
      ]
    },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Main Contact Phone Number:*',
          mapping: 'telnumber'
        }
      ]
    },
    {
      fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Alternate Number or Cell Number:*',
          mapping: 'cellnumber'
      }
  ]
  },
  {
    fields: [
      {
        type: 'text',
        size: 'Medium',
        label: 'Main Contact Email Address:*',
        mapping: 'email'
      }
    ]
  },
  {
    fields: [
      {
        type: 'text',
        size: 'Medium',
        label: 'Website: (If Applicable)',
        mapping: 'website'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Name:*',
            mapping: 'partyname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Starting Date:*',
            mapping: 'eventDate'
          }
        ]
      },
    {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Event Type:*',
          options: [
            { label: 'Banquet Plated', value: 'Banquet Plated'},
            { label: 'Banquet Buffet', value: 'Banquet Buffet'},
            { label: 'Mixer', value: 'Mixer' },
            { label: 'Theater Style', value: 'Theater Style' },
            { label: 'Classroom Style', value: 'Classroom Style' },
            { label: 'Other', value: 'Other'}
          ],
          mapping: 'theme'
        }
      ]
    },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Estimated Guest Count:*',
          mapping: 'plannedguestcount'
        }
      ]
    },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'AHERN Hotel Contact Form',
    formId: '2027',
    clientKey: 'BB23719C-A81B-4898-B9FF-D3B36DC3669A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://ahernhotel.com/event_inquiry_confirmation/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
